<template>
  <div v-bind="$attrs">
    <component
      v-for="option in options"
      :key="option.value"
      :is="vertical ? 'div' : 'span'"
      :class="groupClass"
    >
      <BaseRadio
        :label="option.label"
        :value="option.value"
        :modelValue="value"
        :name="radioGroupName"
        :inputClass="inputClass"
        :labelClass="labelClass"
        @input='onInput'
      />
    </component>
  </div>
</template>

<script>
import BaseRadio from '@/components/BaseRadio'

export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    },
    vertical: {
      type: Boolean,
      default: false
    },
    groupClass: {
      type: String,
      default: ''
    },
    inputClass: {
      type: String,
      default: ''
    },
    labelClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    radioGroupName () {
      return `radio-group-${this._uid}`
    }
  },
  methods: {
    onInput (value) {
      this.$emit('input', value)
    }
  },
  components: {
    BaseRadio
  }
}
</script>
